import React from 'react';
import { useParams } from 'react-router-dom';

const RouteDetail: React.FC = () => {
  const { id } = useParams();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Детали маршрута {id}</h1>
      <p className="text-gray-600">Эта страница будет реализована в следующей итерации.</p>
    </div>
  );
};

export default RouteDetail; 